import { Color } from 'three';
import { IGradient } from '../types';

export const YELLOW_GREEN: IGradient = [
  [0, new Color(0.1647, 0.2824, 0.3451)],
  [0.1, new Color(0.1338, 0.3555, 0.4227)],
  [0.2, new Color(0.061, 0.4319, 0.4864)],
  [0.3, new Color(0.0, 0.5099, 0.5319)],
  [0.4, new Color(0.0, 0.5881, 0.5569)],
  [0.5, new Color(0.137, 0.665, 0.5614)],
  [0.6, new Color(0.2906, 0.7395, 0.5477)],
  [0.7, new Color(0.4453, 0.8099, 0.5201)],
  [0.8, new Color(0.6102, 0.8748, 0.485)],
  [0.9, new Color(0.7883, 0.9323, 0.4514)],
  [1, new Color(0.9804, 0.9804, 0.4314)],
];
